import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const ChickenContext = createContext();

export const ChickenProvider = ({ children }) => {
  const [infoChicken, setInfoChicken] = useState({
    previsaoVendas: 0,
    estoque: 0,
    previsaoProducao: 0,
    custoUnitario: 0,
    receitaProduto: 0,
    pesoCaixa: 1,
    preco: 6.50
  });
  const [insumosChicken, setInsumosChicken] = useState([])
  const [stockChickenMarket, setStockChickenMarket] = useState(0)

  function getChickenStockMp() {

    const storagedCurrentUserGame = JSON.parse(localStorage.getItem('@App:currentUserGame'));

    if (!storagedCurrentUserGame?.supermercado) return

    axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/estoque/obterEstoqueSuperMercado/8/${storagedCurrentUserGame?.supermercado}`)
      .then(response => {
        setStockChickenMarket(response.data ? response.data.quantidade : 0)
      })

  }

  function getChickenStock() {

    const storagedIndustry = JSON.parse(localStorage.getItem('@App:industria'));
    if (!storagedIndustry) return

    axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/estoque/obterEstoqueIndustria/8/${storagedIndustry?.industria}`)
      .then(response => {
        setInfoChicken({
          previsaoVendas: 0,
          estoque: response.data ? response.data.quantidade : 0,
          previsaoProducao: 0,
          custoUnitario: infoChicken.custo,
          receitaProduto: infoChicken.receitaProduto,
          pesoCaixa: 1,
          preco: 6.50
        })
      })

  }

  useEffect(() => {
    const storagedJogo = JSON.parse(localStorage.getItem('@App:jogo'));

    axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/produto/listarInsumos/8`)
      .then(response => {
        console.log(response)
        setInsumosChicken(response.data)

      })

    axios.get("https://sistemas.sisinfor.com.br/BusinessGameBack/api/produto/listarTodos")
      .then(response => {
        const data = response.data[1]

        const storagedIndustry = JSON.parse(localStorage.getItem('@App:industria'));
        const storagedCurrentUserGame = JSON.parse(localStorage.getItem('@App:currentUserGame'));

        if (storagedCurrentUserGame?.supermercado) {
          //get do estoque do supermercado
          axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/estoque/obterEstoqueSuperMercado/8/${storagedCurrentUserGame?.supermercado}`)
            .then(response => {
              setStockChickenMarket(response.data ? response.data.quantidade : 0)
              setInfoChicken({
                custoUnitario: data.custo
              })
            })
        }

        if (!storagedIndustry) return
        axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/estoque/obterEstoqueIndustria/8/${storagedIndustry?.industria}`)
          .then(response => {
            setInfoChicken({
              previsaoVendas: 0,
              estoque: response.data ? response.data.quantidade : 0,
              previsaoProducao: 0,
              custoUnitario: data.custo,
              receitaProduto: infoChicken.receitaProduto,
              pesoCaixa: 1,
              preco: 6.50
            })

          })

      })




  }, []);

  return (
    <ChickenContext.Provider
      value={{
        infoChicken,
        setInfoChicken,
        insumosChicken,
        setInsumosChicken,
        stockChickenMarket,
        getChickenStockMp,
        getChickenStock
      }}
    >
      {children}
    </ChickenContext.Provider>
  );
};

export const useChicken = () => useContext(ChickenContext);
